(function() {
    'use strict';

    function getNewLariUrl() {
        switch (window.location.hostname) {
            case 'localhost':
            case 'lariaiddev.mlb.com':
                return 'https://lari-dev.mlbinfra.com';
            case 'lariaidstg.mlb.com':
                return 'https://lari-stg.mlbinfra.com';
            case 'lariaid.mlb.com':
            default:
                return 'https://lari.mlb.com';
        }
    }

    angular
        .module('lariAidApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngMaterial',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            'ngTouch',
            // angularjs-add-module : add new module here
            'angular-loading-bar',
            'scrollable-table',
            'ngLetterAvatar',
            'ngAnimate',
            'ks.ngScrollRepeat',
            'ng.deviceDetector',
            'ckeditor',
            'vAccordion',
            'ngSanitize',
            'ngNotificationsBar'
        ])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler', '$rootScope'];

    function run(stateHandler, translationHandler, $rootScope) {
        stateHandler.initialize();
        translationHandler.initialize();
        $rootScope.newLariUrl = getNewLariUrl();
    }
})();
